import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useRef } from 'react';

interface Props {
  year: string;
  description: string;
  isLast?: boolean;
}

const Description = styled(Typography)(({ theme }) => ({
  fontFamily: 'Pretendard',
  fontWeight: 400,
  fontSize: '0.75rem',
  lineHeight: 'normal',
  letterSpacing: '0%',
  color: '#EBEDF7',
  flex: 1,
  [theme.breakpoints.up('sm')]: {
    fontWeight: 500,
    fontSize: '1.125rem',
  }
}));

export default function HistoryItem({ year, description, isLast = false }: Props) {
  const descriptionRef = useRef<HTMLParagraphElement>(null);
  const lineRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateLineHeight = () => {
      if (descriptionRef.current && lineRef.current) {
        const descriptionHeight = descriptionRef.current.offsetHeight;
        const vh = window.innerHeight * 0.02; // 2vh
        lineRef.current.style.height = `calc(${descriptionHeight}px + ${vh}px)`;
      }
    };

    updateLineHeight();
    window.addEventListener('resize', updateLineHeight);

    return () => window.removeEventListener('resize', updateLineHeight);
  }, [isLast, description]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: '2vh', position: 'relative' }}>
      {/* 연도 */}
      <Box sx={{ width: '9vw', minWidth: '80px', pr: '1vw', textAlign: 'right' }}>
        <Description sx={{ fontWeight: 600, color: '#ffffffcc', whiteSpace: 'nowrap' }}>
          {year}
        </Description>
      </Box>

      {/* 점 + 선 */}
      <Box sx={{ position: 'relative', width: '12px', minWidth: '12px', mr: '2vw' }}>
        {/* 점 */}
        <Box
          sx={{
            width: '12px',
            height: '12px',
            backgroundColor: '#EBEDF7',
            borderRadius: '50%',
            position: 'relative',
            zIndex: 2,
          }}
        />
        {/* 선 */}
        <Box
          ref={lineRef}
          sx={{
            position: 'absolute',
            top: '12px',
            left: '5px',
            width: '2px',
            background: isLast
              ? 'linear-gradient(to bottom, rgba(235, 237, 247, 1) 0%, rgba(235, 237, 247, 1) 70%, transparent 100%)'
              : 'rgba(235, 237, 247, 1)',
            zIndex: 1,
          }}
        />
      </Box>

      {/* 설명 */}
      <Description ref={descriptionRef}>{description}</Description>
    </Box>
  );
}